module.exports = __webpack_public_path__ + "img/car.4639c00b.png";